import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { catchError, concatMap, Observable, throwError, tap } from 'rxjs';
import { NotificationService } from '../services/notification/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { DialogService } from '../components/dialog/dialog.service';
import { MessageService } from '../services/message/message.service';
import { SERVICE_UNAVALABLE_MESSAGE } from '../const/message/service-unavailable.const';
import { HttpResponse } from '@angular/common/http';
import { AUTH_SESSION_REQUEST } from '../services/auth/auth-http.context';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(
        private translateService: TranslateService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private dialogService: DialogService,
        private router: Router,
        private messageService: MessageService
    ) {}

    private errorCounter = 0;

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // Session initialization owns its errors. In particular, never log a URL carrying a relogin token.
        if (request.context.get(AUTH_SESSION_REQUEST)) return next.handle(request);
        return next.handle(request).pipe(
            tap((event) => {
                if (event instanceof HttpResponse) {
                    if (this.errorCounter > 10) {
                        this.messageService.setInAppErrorMessages(
                            this.messageService
                                .getInAppErrorMessages()()
                                .filter((msg) => msg.id !== SERVICE_UNAVALABLE_MESSAGE.id)
                        );
                    }
                    this.errorCounter = 0;
                }
            }),
            catchError((response: HttpErrorResponse, caught) => this.showError(response, caught))
        );
        /*return next.handle(request).pipe(tap(
            event => event instanceof HttpResponse ? 'succeeded' : '',
            err => {
                console.log("custom xx");
                // this.openSnackBar('danger', "Something went wrong with the request, please try again.");
            }
        ))*/
    }

    private showError<T>(response: HttpErrorResponse, caught: Observable<T>) {
        if (response.status === 0) {
            this.errorCounter++;
        }
        if (this.errorCounter === 3) {
            this.messageService.setInAppErrorMessages([
                ...this.messageService.getInAppErrorMessages()(),
                SERVICE_UNAVALABLE_MESSAGE,
            ]);
        }
        // const text: string = response.error?.message ?? response.error.statusText;
        console.error(response);

        switch (response.status) {
            case 422:
                this.notificationService.danger({
                    message: this.translateService.instant('global.errors.interceptor.422'),
                    action: this.translateService.instant('global.buttons.close'),
                    duration: 3000,
                    position: {
                        vertical: 'top',
                        horizontal: 'end',
                    },
                });
                break;
            case 401:
                this.notificationService
                    .danger({
                        message: this.translateService.instant('global.errors.interceptor.401'),
                        action: this.translateService.instant('global.buttons.re-login'),
                        duration: 3000,
                        position: {
                            vertical: 'top',
                            horizontal: 'end',
                        },
                    })
                    .onAction()
                    .subscribe(() => {
                        this.dialogService.closeAll(); // if modal open
                        this.authService.signOut(); // sign out in app, clear user data
                        this.router.navigate(['/auth/login']); // go to login page
                    });
                break;
            case 402:
                this.notificationService
                    .danger({
                        message: this.translateService.instant('global.errors.interceptor.402'),
                        action: 'Navýšit licenci', // TODO: translate
                        duration: 3000,
                        position: {
                            vertical: 'top',
                            horizontal: 'end',
                        },
                    })
                    .onAction()
                    .subscribe(() => {
                        this.dialogService.closeAll(); // if modal open
                        this.authService.signOut(); // sign out in app, clear user data
                        this.router.navigate(['/auth/login']); // go to login page
                    });
                break;
            case 0:
                this.notificationService
                    .danger({
                        message: this.translateService.instant('global.errors.interceptor.0'),
                        action: this.translateService.instant('global.buttons.repeat'),
                        position: {
                            vertical: 'top',
                            horizontal: 'end',
                        },
                    })
                    .onAction()
                    .pipe(concatMap(() => caught));
                break;
            default:
                console.error(response);
        }
        return throwError(response);

        // throw HttpErrorResponse()
        // return EMPTY;
    }
}
